<template>
  <Catalog
    title="Статус заявки на подбор"
    name-label="Название статуса"
    submit-error="Укажите название статуса заявки на подбор."
    :fetch-data="fetchData"
    :put-data="putData"
    :post-data="postData"
    :exact-id="createId"
    v-on="$listeners"
  />
</template>

<script>
import catalogs from "../../../network/catalogs";
  import Catalog from "../Catalog.vue";

export default {
  name: "RecruitTaskStatus",
  components: { Catalog },
  mixins: [ catalogs ],
  props: {
    createId: { type: Number }
  },
  methods: {
    async fetchData(id) {
      return await this.getRecruitTaskStatusById(id);
    },
    async putData(data) {
      return await this.putRecruitTaskStatus(data)
    },
    async postData(data) {
      return await this.postRecruitTaskStatus(data)
    },
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Catalogs/RecruitTaskStatuses/RecruitTaskStatus.vue